exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive-video {\n  position: relative;\n  display: block;\n  height: 0;\n  /* 56.25% is 16 by 9 aspect ratio */\n  padding: 0 0 56.25% 0;\n  overflow: hidden;\n}\n.responsive-video iframe {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}", ""]);

// exports
